/* eslint-disable @typescript-eslint/naming-convention */

import { ApiMenuCartItem, NativeLocalCart } from "./LocalCart";
import { CartItem } from "./menu-items";

export interface GroupOrderRestaurantDetails {
    restaurant_id: string;
    restaurant_name: string;
    area_name: string;
}

interface UserDetails {
    user_id: string;
    user_first_name: string;
    user_last_name: string;
}

export interface UserSpecificDetails {
    user_details: UserDetails;
    user_cart: CartItem[];
}

export interface UsersOrderMap {
    [userId: string]: UserSpecificDetails;
}

export enum CtaAction {
    CLEAR_CART = "clearCart",
    GO_TO_HOME = "goToHome",
    GO_TO_SIMILAR_RESTAURANT = "goToSimilarRestaurants",
    GO_TO_LOGIN = "goToLogin",
}

export interface GetGroupCartOrderResponse {
    statusCode: number;
    statusMessage: string;
    statusTitle: string;
    ctaText?: string;
    titleMessage?: string;
    ctaAction?: CtaAction;
    data: {
        host_user_id: string;
        group_cart_id: string;
        user_cart_map: UsersOrderMap;
        restaurant_details: GroupOrderRestaurantDetails;
        address_id: string;
        locked_status?: boolean;
    };
}

export type UpdateGroupCartOrderResponse = GetGroupCartOrderResponse;

export interface IUpdateGroupCartOrderRequestPayload {
    restaurant_id: string;
    address_id: string;
    group_cart_id: string;
    host_user_id: string;
    user_id: string;
    cartItems: ApiMenuCartItem[];
    mealItems: [];
}

export interface GroupOrderError {
    error: boolean;
    statusCode?: number;
    titleMessage?: string;
    statusMessage?: string;
    ctaText?: string;
    ctaAction?: string;
}

export interface GroupOrderState {
    data?: GetGroupCartOrderResponse["data"];
    getSharedCartLoading?: boolean;
    updateSharedCartLoading?: boolean;
    error: GroupOrderError;
    softError?: string;
    isCartLocked: boolean;
    diffString?: string;
}

export interface LockGroupCartOrderResponse {
    statusCode: number;
    statusMessage: string;
    statusTitle: string;
    ctaText?: string;
    titleMessage?: string;
    ctaAction?: CtaAction;
    data: {
        merged_cart_payload: NativeLocalCart;
    };
}

export interface GroupOrderAnalyticsPayload {
    groupCartId: string;
    isInitiator: boolean;
    userId: string;
    restId: string;
    isCurrentItemFromSameUser?: boolean;
    isGroupCart?: boolean;
}
